export const contactLabel = (contact) =>
  [contact?.name, contact?.lastName].filter(Boolean).join(" ").trim() ||
  `#${contact?.id || ""}`;

export const userLabel = (user) =>
  [user?.name, user?.username].filter(Boolean)[0] ||
  (user?.id ? `#${user.id}` : "-");

export const formatHours = (value) => {
  const num = Number(value);
  if (value === null || value === undefined || Number.isNaN(num)) return "-";
  return num.toFixed(2);
};

export const formatElapsed = (startedAt) => {
  if (!startedAt) return "00:00:00";
  const seconds = Math.max(
    0,
    Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000)
  );
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return [h, m, s].map((n) => String(n).padStart(2, "0")).join(":");
};

const localeForLang = () =>
  String(localStorage.getItem("lang") || "en").toUpperCase() === "FA"
    ? "fa-IR"
    : undefined;

export const formatTimeEntryDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString(localeForLang(), {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

export const formatTimeEntryClock = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(localeForLang(), {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const formatWorkedRange = (startedAt, endedAt, template) => {
  if (!startedAt || !endedAt) return "";
  const start = formatTimeEntryClock(startedAt);
  const end = formatTimeEntryClock(endedAt);
  if (template && template.includes("{start}")) {
    return template.replace("{start}", start).replace("{end}", end);
  }
  return `Worked from ${start} to ${end}`;
};

export const displayDescription = (entry, template) => {
  const work = String(entry?.description || "").trim();
  const range = formatWorkedRange(entry?.startedAt, entry?.endedAt, template);
  if (!range) return work || "-";
  return work ? `${work}\n${range}` : range;
};

export const toLocalInputValue = (value) => {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
